<template>
    <div class="SessionTimeout">
        <b-modal ref="component-modal" title="Your screen has locked. Please enter your password to unlock."  modal-class="fullscreen-modal" hide-header-close hide-footer no-fade no-close-on-backdrop no-close-on-esc>
            <b-container>
                <b-row>
                    <b-col></b-col>
                    <b-col>
                        <b-form @submit="Confirm">
                            <div class="form-group">
                                <label><b>Password:</b></label>
                                <input type="password" v-model="Password" ref="showfocus" class="form-control" required />
                            </div>
                            <b-row class="modal-btn-row">
                                <div class="modal-btn-row-div">
                                    <b-button size="md" variant="danger" @click="LogoutUser()" style="float:left;">
                                        LOGOUT
                                    </b-button>
                                    <b-button size="md" variant="success" type="submit">
                                        CONTINUE
                                    </b-button>
                                </div>
                            </b-row>
                        </b-form>
                    </b-col>
                    <b-col></b-col>
                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>
<script>
    import { EventBus } from '../../../services/event-bus.js';
    export default {
        name: "SessionTimeout",
        created() {
            let vm = this;
            document.addEventListener('click', vm.ResetTimer);
            document.addEventListener('keydown', vm.ResetTimer);
            document.addEventListener('mousemove', vm.ResetTimer);
            this.ResetTimer();

        },
        props: [
            "TimeoutSeconds"
        ],
        data: function () {
            return {
                Password: "",
                Locked: false,
                TimeoutSeconds: 180,
                WarningSeconds: 60,
                TimeoutTime: null,
                WarningTime: null,
                IntervalVar: null,
                ModalIsShow: false,
                RemainingSeconds: 0
            }
        },
        methods: {
            Confirm(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Core/User/CheckPassword", { Password: this.Password }, this.ConfirmSuccess, () => { }, true);
            },
            ConfirmSuccess(response) {
                this.Locked = false;
                window.removeEventListener('beforeunload',this.LogoutUser);
                this.$refs['component-modal'].hide();
            },
            ShowModal: function () {
                this.Password = "";
                this.$refs['component-modal'].show();
            },
            HandleShown() {
                this.$refs.showfocus.focus();
            },
            ResetTimer() {
                let vm = this;
                if (this.IntervalVar != null) {
                    clearInterval(this.IntervalVar);
                }
                this.TimeoutTime = moment().add(this.TimeoutSeconds, 'seconds');
                this.WarningTime = moment().add(this.WarningSeconds, 'seconds');
                this.IntervalVar = setInterval(function () {
                    if (vm.TimeoutTime < moment()) {
                        vm.Locked = true;
                        vm.$refs["component-modal"].show();
                        vm.ShowModal();
                    }
                }, 990);

            },
            LogoutUser() {
                let vm = this;
                clearInterval(vm.IntervalVar);
                document.removeEventListener('click', vm.ResetTimer);
                document.removeEventListener('keydown', vm.ResetTimer);
                document.removeEventListener('mousemove', vm.ResetTimer);
                window.removeEventListener('beforeunload', this.LogoutUser);
                this.$MasterAPI.ExecuteRequest("POST", "Core/User/Logout", null, this.LogoutUserSuccess, () => { }, false);
            },
            LogoutUserSuccess(response) {
                window.location.href = this.$baseURL;
            }
        }
    };
</script>
<style scoped>
    /deep/.fullscreen-modal .modal-dialog {
        max-width: 100%;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100vh;
        display: flex;
        position: fixed;
        z-index: 100000;
    }
</style>